import React, { Component } from "react";
import {Container} from "react-bootstrap";
export default class About extends Component {
  render() {
    return (
      <>
        <Container className="w-50">
          <h2 style={{marginTop:20}}>
            Неприглядный бетон в умелых руках может превратиться в шедевр
            забора, который станет визитной карточкой хозяина.
          </h2>
          <h2 className="text-center" style={{marginTop:20}}>Изливаем душу -<u>   в камень !  </u></h2>
        </Container>
      </>
    );
  }
}
